import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusAuto: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFocusAuto"><Path d="M8.75 3H3V8.75H4.5V4.5H8.75V3Z" fill="currentColor"/><Path d="M21 3H15.25V4.5H19.5V8.75H21V3Z" fill="currentColor"/><Path d="M4.5 19.5V15.25H3V21H8.75V19.5H4.5Z" fill="currentColor"/><Path d="M21 21V15.25H19.5V19.5H15.25V21H21Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M8 16L11.0259 8H12.9741L16 16H14.2929L13.8232 14.7582H10.1768L9.70708 16H8ZM12 9.93791L13.1249 12.9121H10.8751L12 9.93791Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFocusAuto;
